import { render } from "./InfoPageTemplate.vue?vue&type=template&id=761c1d05"
import script from "./InfoPageTemplate.vue?vue&type=script&lang=js"
export * from "./InfoPageTemplate.vue?vue&type=script&lang=js"

import "./InfoPageTemplate.vue?vue&type=style&index=0&id=761c1d05&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__